import { useEffect } from 'react';
import ABeagleContext from '../../contexts/abeagle';
import { isAmazon } from '@buzzfeed/bf-utils/lib/affiliate-link';
import { useAmazonSubtagModifier as useAmazonSubtagModifierFromPackages } from '@buzzfeed/react-components/lib/hooks/useAmazonSubtagModifier';
import { queryStringToObject } from '@buzzfeed/bf-utils/lib/query-string';

const ARB_BOOSTING_TAG = 'bfpaidboosting-20';

/**
 * Replace just the `tag` query param value in a URL without re-encoding
 * other params (avoids double-encoding ascsubtag).
 */
const replaceTagParam = (href, newTag) => {
  return href.replace(/([\?&])tag=[^&#]*/, `$1tag=${newTag}`);
};

export function useAmazonSubtagModifier({ buzz = {} }) {
  const ref = useAmazonSubtagModifierFromPackages({ buzz, ABeagleContext });
  const element = ref?.current;

  // force link conversion in case of commerce api failure
  useEffect(() => {
    if (!buzz.is_convert_enabled || !element || element.querySelector('a[data-affiliate]')) {
      return;
    }
    element.querySelectorAll('a[href*="amazon"]:not([data-affiliate])').forEach(link => {
      if (isAmazon(link.href)) {
        // normally set on the back-end, this attribute indicates that the link is an affiliate link
        // and should be tracked and converted
        link.setAttribute('data-affiliate', 'true');
      }
    });
  }, [element, buzz]);

  // Override Amazon tracking ID for ARB boosting traffic (RT-2245)
  useEffect(() => {
    if (!element) return;
    const { origin } = queryStringToObject(window.location.search);
    if (!origin || !origin.includes('arb')) return;

    element.querySelectorAll('a[href]').forEach(link => {
      if (isAmazon(link.href)) {
        link.href = replaceTagParam(link.href, ARB_BOOSTING_TAG);
      }
    });
  }, [element, buzz.id]);

  return ref;
}
